import ReactDOM from 'react-dom';

export function getElement(appSelector) {
    const element = document.querySelector(appSelector);
    if (!element) {
        throw new Error(`Can't init React app. Selector ${appSelector} not found`);
    }
    return element;
}

/* eslint-disable-next-line */
export function _initReactApp(appSelector, renderContent) {
    const element = getElement(appSelector);
    ReactDOM.render(
        renderContent,
        element,
    );
}

export default function initReactApp(appSelector, renderContent, immediateRender = false) {
    if (immediateRender || document.readyState === 'complete') {
        _initReactApp(appSelector, renderContent);
    } else {
        window.addEventListener(
            'load',
            _initReactApp.bind(this, appSelector, renderContent),
        );
    }
}

function toCamelCase(string) {
    return string.replace(/([-_][a-z])/ig, (firstMatch) => (
        firstMatch.toUpperCase()
            .replace('-', '')
            .replace('_', '')
    ));
}

export function extractParamsFromElement(element, convertToCamelCase = false) {
    const params = {};
    for (let i = 0; i < element.attributes.length; i += 1) {
        const attr = element.attributes[i];
        if (attr.name.indexOf('data-') > -1) {
            let paramName = attr.name.replace('data-', '');
            if (convertToCamelCase) {
                paramName = toCamelCase(paramName);
            }
            params[paramName] = attr.value;
        }
    }
    return params;
}

export function extractParams(appSelector, convertToCamelCase = false) {
    return extractParamsFromElement(
        getElement(appSelector),
        convertToCamelCase,
    );
}
